import { FinishedTicketRequisite } from '../core/_models'

/** Реквизит, выданный клиенту по пополнению: значение целиком, банк и держатель; пустые строки не выводятся. */
export const FinishedTicketRequisiteCell = ({ requisite }: { requisite?: FinishedTicketRequisite | null }) => (
  <td>
    {requisite ? (
      <div className='text-dark'>
        <div>
          <strong>Реквизит:</strong> <span>{requisite.identifier}</span>
        </div>
        {requisite.bank && (
          <div>
            <strong>Банк:</strong> <span>{requisite.bank}</span>
          </div>
        )}
        {requisite.cardholder && (
          <div>
            <strong>Держатель:</strong> <span>{requisite.cardholder}</span>
          </div>
        )}
      </div>
    ) : (
      <span className='text-muted'>-</span>
    )}
  </td>
)
